import { BaseQuestionnaireRoute } from '../slice';

export type GeneralInfoRoutes = BaseQuestionnaireRoute;

export const generalInfoRoutes: { generalInfo: GeneralInfoRoutes } = {
    generalInfo: {
    title: 'General Info',
    path: 'generalInfo',
    isValid: undefined,
  },
};
